import React from 'react';
import { useParams } from 'react-router-dom';
import './App.css';
import Hero from './components/Hero';
import Countdown from './components/Countdown';
import OurStory from './components/OurStory';
import Details from './components/Details';
import Timeline from './components/Timeline';
import RSVPForm from './components/RSVPForm';
import Footer from './components/Footer';
import PhotoGrid from './components/PhotoGrid';
import DressCode from './components/DressCode';
import FlowerGift from './components/FlowerGift';
import { getGuestByInvitationId } from './data/guests';
import { Analytics } from "@vercel/analytics/react"

function App() {
    const {invitationId} = useParams<{ invitationId: string }>();
    const guest = getGuestByInvitationId(invitationId);

    return (
        <div className="App">
            <Analytics/>
            <Hero guestName={guest.name} message={guest.message}/>
            <Countdown/>
            <div className="section-separator"/>
            <OurStory/>
            <PhotoGrid/>
            <div className="section-separator"/>
            <DressCode/>
            <div className="section-separator"/>
            <Details/>
            <Timeline/>
            <div className="section-separator"/>
            <RSVPForm guestName={guest.name} invitationId={invitationId} multiplePersons={guest.multiplePersons}/>
            <div className="section-separator"/>
            <FlowerGift/>
            <Footer/>
        </div>
    );
}

export default App;
